module.exports = "/_next/static/images/introTextBlockImage-23f4be84273080ee099c082aec7a03be.jpeg";